<script>
  export let message;

  // let size = 3;
  // let unit = "em";
  // let color = "#fff";
  // let duration = "2s";
</script>

<div class="spinner">
  <span class="spin"></span>
  <span class="spinner-message check">{message}</span>
</div>

<style>
  .spinner {
    padding: 10px;
    text-align: center;
    background: transparent;
  }
  .spin {
        display: inline-block;
        width: 50px;
        height: 50px;
        border: 3px solid #1d134b;
        border-radius: 50%;
        border-top-color:#fff;
        animation: spin 1s ease-in-out infinite;
        -webkit-animation: spin 1s ease-in-out infinite;
      }
      @keyframes spin {
        to {
          -webkit-transform: rotate(360deg);
        }
      }
      @-webkit-keyframes spin {
        to {
          -webkit-transform: rotate(360deg);
        }
      }

  .spinner-message {
    display: block;
    margin: 10px auto;
  }

</style>
